import { render, staticRenderFns } from "./vue-qz-tray-form-element.vue?vue&type=template&id=632754c8&scoped=true&"
import script from "./vue-qz-tray-form-element.vue?vue&type=script&lang=js&"
export * from "./vue-qz-tray-form-element.vue?vue&type=script&lang=js&"
import style0 from "./vue-qz-tray-form-element.vue?vue&type=style&index=0&id=632754c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632754c8",
  null
  
)

export default component.exports